import React, { useEffect, useRef, useState } from "react";
import {
	Button,
	SelectPicker,
	CheckPicker,
	Checkbox,
	Row,
	Col,
	useToaster,
	Notification,
	Whisper,
	Popover,
} from "rsuite";

import { useDispatch, useSelector } from "react-redux";
import {
	getPricingFiltersnew,
	getPricingCustomerListData,
	getPricingDistrictLevelData,
	getPricingDivsionDataByCustomer,
	getPricingExportData,
} from "../../queries/apiQueries";
import CustomerSummaryTable from "./customerSummaryTable";
import Filters from "./Filters";
import DivisionWiseTable from "./DivisionWiseTable";
import { numberFormatter } from "../../utils";
import { BubbleScatterWithZoom } from "./BubbleScatterWithZoom";
import "./index.scss";
import { CUST_SUB_MKT } from "../../config/constants";
import MainHeader from "../../components/Layouts/MainHeader";
import MainContent from "../../components/Layouts/MainContent";
import { Loader } from "../../components/common/Loader";
import InfoOutlineIcon from "@rsuite/icons/InfoOutline";
import { getTimelineOptions } from "../../config/constants";
const Pricing = (props: any) => {
	const timelineOptions=getTimelineOptions()
	const allFilters = useSelector(
		(state: any) => state.CommonReducer.allFilters
	);

  	const timeline = useSelector((state: any) => state.CommonReducer.timeline);

	var isCleared = false;
	const didClear: any = useRef(false);
	const dispatch = useDispatch<any>();
	const toaster = useToaster();

	const [filtersLoading, setFiltersLoading] = useState(true);
	const [isLoading, setIsLoading] = useState(true);
	const [tableLoading, setTableLoading] = useState(true);
	const [customerList, setCustomerList] = useState<Array<any>>([]);
	const [totalOppAndRev, setTotalOppAndRev] = useState<Array<any>>([]);
	const [customerPricingData, setCustomerPricingData] = useState<any>({});
	const [selectedCustomerList, setSelectedCustomerList] = useState<any>(null);
	const [selectedCustomer, setSelectedCustomer] = useState<any>(null);
	const [searchItemId, setSearchItemId] = useState<any>(null);
	const [searchCustName, setSearchCustName] = useState<any>(null);
	const [selectedCustomerData, setSelectedCustomerData] = useState<any>(null);
	const [minYAxisValue, setMinYAxisValue] = useState<any>(0);
	const [maxYAxisValue, setMaxYAxisValue] = useState<any>(0);
	const [exportData, setExportData] = useState<any>([]);
	const [ExportFlag, setExportFlag] = useState(false);
	const [isVisible, setIsVisible] = useState(false);
	const [isRightVisible, setIsRightVisible] = useState(false);
	const [selectedItemId, setSelectedItemId] = useState<any>(null);
	const [selectedDistrict, setSelectedDistrict] = useState<any>(null);
	const [selectedPeerName, setSelectedPeerName] = useState<any>(null);
	const [selectedItemObject, setSelectedItemObject] = useState<any>(null);
	const [selectedDistrictObject, setSelectedDistrictObject] =
		useState<any>(null);
	const [selectedPeerNameObject, setSelectedPeerNameObject] =
		useState<any>(null);
	const [pageNumber, setPageNumber] = useState(1);
	const [count, setCount] = useState(0);

	const [filterOptions, updateFilterOptions] = useState<any>({
		l1: new Array<{ l1: string }>(),
		l2: new Array<{ l2: string }>(),
		l3: new Array<{ l3: string }>(),
		l4: new Array<{ l4: string }>(),
	});
	const [selectedFilters, setSelectedFilters] = useState<any>({
		...allFilters,
	});

	const [selectedTimeline, setSelectedTimeline] = useState(timeline ? timeline:
		getTimelineOptions()[0]?.value
	);

	const [extraFilters, setExtraFilters] = useState<any>({
		custSize: new Array<{ custSize: string }>(),
		customerSubMarket: new Array<{ customerSubMarket: string }>(),
		custMarket: new Array<{ custMarket: string }>(),
		district: new Array<{ district: string }>(),
		projectFlag: new Array<{ projectFlag: string }>(),
		salesOffice: new Array<{ salesOffice: string }>(),
		startification: new Array<{ startification: string }>(),
	});

	const [initialFilterValues, setInitialFilterValues] = useState<any>({
		custSize: new Array<{ custSize: string }>(),
		customerSubMarket: new Array<{ customerSubMarket: string }>(),
		custMarket: new Array<{ custMarket: string }>(),
		district: new Array<{ district: string }>(),
		projectFlag: new Array<{ projectFlag: string }>(),
		salesOffice: new Array<{ salesOffice: string }>(),
		startification: new Array<{ startification: string }>(),
	});

	const token = useSelector((state: any) => state.CommonReducer.token);

	const filtersMount: any = useRef(false);
	const didMount: any = useRef(true);

	const footerStyles = {
		padding: "10px 2px",
		borderTop: "1px solid #e5e5e5",
	};

	/* on changing timeline */
	const timelineHandler = (e: any) => {
		setSelectedTimeline(e === null ? "All" : e);
	};

	/* Filters api call */
	const getFilters = async (
		payload: any = {},
		currentFilter: any = "all",
		fo: any = null
	) => {
    	payload.timeline = selectedTimeline;

		setFiltersLoading(true);
		let res = await dispatch(getPricingFiltersnew(payload));

		if (fo) {
			if (currentFilter === "l1") {
				updateFilterOptions({
					...fo,
					l2: [...res.l2],
					l3: [...res.l3],
					l4: [...res.l4],
				});
			} else if (currentFilter === "l2") {
				updateFilterOptions({
					...fo,
					l3: [...res.l3],
					l4: [...res.l4],
				});
			} else if (currentFilter === "l3") {
				updateFilterOptions({
					...fo,
					l4: [...res.l4],
				});
			} else if (currentFilter === "l4") {
				updateFilterOptions({
					...fo,
				});
			} else {
				updateFilterOptions({
					l1: res.l1,
					l2: res.l2,
					l3: res.l3,
					l4: res.l4,
				});
			}
		} else {
			if (currentFilter === "l1") {
				updateFilterOptions({
					...filterOptions,
					l2: [...res.l2],
					l3: [...res.l3],
					l4: [...res.l4],
				});
			} else if (currentFilter === "l2") {
				updateFilterOptions({
					...filterOptions,
					l3: [...res.l3],
					l4: [...res.l4],
				});
			} else if (currentFilter === "l3") {
				updateFilterOptions({
					...filterOptions,
					l4: [...res.l4],
				});
			} else if (currentFilter === "l4") {
				updateFilterOptions({
					...filterOptions,
				});
			} else {
				updateFilterOptions({
					l1: res.l1,
					l2: res.l2,
					l3: res.l3,
					l4: res.l4,
				});
			}
		}

		res?.customerSubMarket?.forEach((val: any) => {
			let index = CUST_SUB_MKT?.findIndex(
				(e: any) => e?.key === val?.customerSubMarket
			);
			if (index > -1) {
				val.label = CUST_SUB_MKT[index]?.value;
			}
		});

		setIsLoading(false);
		setFiltersLoading(false);
		filtersMount.current = false;
		setInitialFilterValues(res);
		return res;
	};

	const handleClear = (filter: string) => {
		isCleared = true;
		didClear.current = true;
		if (filter === "l1") {
			setSelectedFilters({
				...selectedFilters,
				l1: [],
				l2: [],
				l3: [],
				l4: [],
				supplier: [],
			});
			getFilters(
				{
					...selectedFilters,
					l1: [],
					l2: [],
					l3: [],
					l4: [],
					supplier: [],
				},
				"l1"
			);
			getCustomerData(null, null, null, {
				l1: [],
				l2: [],
				l3: [],
				l4: [],
			});
		} else if (filter === "l2") {
			setSelectedFilters({
				...selectedFilters,
				l2: [],
				l3: [],
				l4: [],
				supplier: [],
			});
			getFilters({ ...selectedFilters, l2: [], l3: [], l4: [] }, "l2");
			getCustomerData(null, null, null, {
				...selectedFilters,
				l2: [],
				l3: [],
				l4: [],
			});
		} else if (filter === "l3") {
			// handleClose('l2');
			setSelectedFilters({
				...selectedFilters,
				l3: [],
				l4: [],
				supplier: [],
			});
			getFilters(
				{ ...selectedFilters, l3: [], l4: [], supplier: [] },
				"l3"
			);
			getCustomerData(null, null, null, {
				...selectedFilters,
				l3: [],
				l4: [],
			});
		} else if (filter === "l4") {
			setSelectedFilters({ ...selectedFilters, l4: [] });
			getFilters({ ...selectedFilters, l4: [] }, "l4");
			getCustomerData(null, null, null, { ...selectedFilters, l4: [] });
		}
	};

	const handleSearch = () => {
		getCustomerData(searchItemId, searchCustName);
	};

	/* Updating filter selection state  */
	const handleFilterUpdate = (value: any, filter: string) => {
		if (isCleared) {
			isCleared = false;
			return;
		}
		filtersMount.current = true;
		let x: string = filter;
		setPageNumber(1);
		if (x == "l1") {
			setSelectedFilters({ l1: value, l2: [], l3: [], l4: [] });
		} else if (x == "l2") {
			setSelectedFilters({
				...selectedFilters,
				l2: value,
				l3: [],
				l4: [],
			});
		} else if (x == "l3") {
			setSelectedFilters({ ...selectedFilters, l3: value, l4: [] });
		} else if (x == "l4") {
			setSelectedFilters({ ...selectedFilters, l4: value });
		}

		// setSelectedFilters({ ...selectedFilters, [x]: value });
		selectedFilters[x] = value;
		setSelectedCustomer(null);
	};

	/* Updating filter options based on selection (api) */
	const handleClose = (filter: string) => {
		if (filter === "l1") {
			setSelectedFilters({ ...selectedFilters, l2: [], l3: [], l4: [] });
			getFilters({ ...selectedFilters, l2: [], l3: [], l4: [] }, "l1");
			getCustomerData();
		} else if (filter === "l2") {
			setSelectedFilters({ ...selectedFilters, l3: [], l4: [] });
			getFilters({ ...selectedFilters, l3: [], l4: [] }, "l2");
			getCustomerData();
		} else if (filter === "l3") {
			setSelectedFilters({ ...selectedFilters, l4: [] });
			getFilters({ ...selectedFilters, l4: [] }, "l3");
			getCustomerData();
		} else if (filter === "l4") {
			// setIsLoading(true);
			setSelectedFilters({ ...selectedFilters });
			getCustomerData();
		}
	};

	const getCustomerData = async (
		searchItemIdLocal: any = null,
		searchCustNameLocal: any = null,
		filterData: any = null,
		mainFilters: any = null
	) => {
		setTableLoading(true);
		let payload: any = {
			l1: selectedFilters.l1,
			l2: selectedFilters.l2,
			l3: selectedFilters.l3,
			l4: selectedFilters.l4,
		    timeline: selectedTimeline,
			projectFlag: [],
			district: [],
			custMarket: [],
			salesOffice: [],
			custSize: [],
			startification: [],
			customerSubMarket: [],
			customer: "",
			itemid: "",
			pageNumber: pageNumber,
			pageSize: 10,
		};

		if (searchItemIdLocal) {
			payload.itemid = searchItemIdLocal;
		}
		if (searchCustNameLocal) {
			payload.customer = searchCustNameLocal;
		}

		if (filterData) {
			payload.projectFlag = filterData.projectFlag;
			payload.district = filterData.district;
			payload.custMarket = filterData.custMarket;
			payload.salesOffice = filterData.salesOffice;
			payload.custSize = filterData.custSize;
			payload.startification = filterData.startification;
			payload.customerSubMarket = filterData.customerSubMarket;

			if (searchCustName) {
				payload.customer = searchCustName;
			}
			if (searchItemId) {
				payload.itemid = searchItemId;
			}
		}

		if (mainFilters) {
			payload.l1 = mainFilters?.l1;
			payload.l2 = mainFilters?.l2;
			payload.l3 = mainFilters?.l3;
			payload.l4 = mainFilters?.l4;
		}

		if (
			extraFilters &&
			!filterData &&
			!searchItemIdLocal &&
			!searchCustNameLocal
		) {
			payload.projectFlag = extraFilters.projectFlag;
			payload.district = extraFilters.district;
			payload.custMarket = extraFilters.custMarket;
			payload.salesOffice = extraFilters.salesOffice;
			payload.custSize = extraFilters.custSize;
			payload.startification = extraFilters.startification;
			payload.customerSubMarket = extraFilters.customerSubMarket;

			if (searchCustName) {
				payload.customer = searchCustName;
			}
			if (searchItemId) {
				payload.itemid = searchItemId;
			}
		}

		getPricingCustomerListData(payload)
			.then((res: any) => {
				if (res.data) {
					res.data.data.sort(
						(x: any, y: any) =>
							y.lostOpportunity - x.lostOpportunity
					);
					setCustomerList(res?.data?.data);
					setCount(res?.data?.count);
					setTotalOppAndRev(res?.data?.records);
				}
				//   setLoading(false);
				setTableLoading(false);
			})
			.catch((err) => {
				//   setLoading(false);
				setTableLoading(false);

				console.log(err);
			});
		didMount.current = false;
	};

	const getDivisionList = async (itemID: any, master_vendor_name: any) => {
		let payload: any = {
			l1: selectedFilters.l1,
			l2: selectedFilters.l2,
			l3: selectedFilters.l3,
			l4: selectedFilters.l4,
		    timeline: selectedTimeline,
			projectFlag: [],
			district: [],
			custMarket: [],
			salesOffice: [],
			custSize: [],
			startification: [],
			customerSubMarket: [],
			customer: "",

			itemid: itemID,
			master_vendor_name: master_vendor_name,
			pageNumber: pageNumber,
			pageSize: 10,
		};

		if (extraFilters) {
			payload.projectFlag = extraFilters.projectFlag;
			payload.district = extraFilters.district;
			payload.custMarket = extraFilters.custMarket;
			payload.salesOffice = extraFilters.salesOffice;
			payload.custSize = extraFilters.custSize;
			payload.startification = extraFilters.startification;
			payload.customerSubMarket = extraFilters.customerSubMarket;

			if (searchCustName) {
				payload.customer = searchCustName;
			}
			if (searchItemId) {
				payload.itemid = searchItemId;
			}
		}

		getPricingDistrictLevelData(payload)
			.then((res: any) => {
				if (res.data) {
					let newList = JSON.parse(JSON.stringify(customerList));

					newList.map((item: any, k: any) => {
						if (item.sku === itemID) {
							res.data.data = res.data.data?.sort(
								(x: any, y: any) =>
									y.lostOpportunity - x.lostOpportunity
							);
							res.data.data.map((p: any, pIndex: any) => {
								p.peerData = p?.peerData?.sort(
									(x: any, y: any) =>
										y.lostOpportunity - x.lostOpportunity
								);
								// p?.peerData.map((c:any,cIndex:any)=>{
								//   c.customerData = c.customerData.sort(
								//     (x: any, y: any) =>
								//       y.lostOpportunity - x.lostOpportunity
								//   );
								// })
							});
							newList[k].divisionList = res.data.data;
						}
					});

					setCustomerList(newList);
				}
				//   setLoading(false);
			})
			.catch((err) => {
				//   setLoading(false);
				console.log(err);
			});
	};

	const getCustomerList = async (
		itemID: any,
		master_vendor_name: any,
		peerGroupDistrict: any,
		peerGroupName: any
	) => {
		let payload: any = {
			l1: selectedFilters.l1,
			l2: selectedFilters.l2,
			l3: selectedFilters.l3,
			l4: selectedFilters.l4,
    		timeline: selectedTimeline,
			projectFlag: [],
			district: [],
			custMarket: [],
			salesOffice: [],
			custSize: [],
			startification: [],
			customerSubMarket: [],
			customer: "",
			itemid: itemID,
			master_vendor_name: master_vendor_name,
			peerGroupDistrict: peerGroupDistrict,
			peerGroupName: peerGroupName,
			pageNumber: pageNumber,
			pageSize: 10,
		};

		if (extraFilters) {
			payload.projectFlag = extraFilters.projectFlag;
			payload.district = extraFilters.district;
			payload.custMarket = extraFilters.custMarket;
			payload.salesOffice = extraFilters.salesOffice;
			payload.custSize = extraFilters.custSize;
			payload.startification = extraFilters.startification;
			payload.customerSubMarket = extraFilters.customerSubMarket;

			if (searchCustName) {
				payload.customer = searchCustName;
			}
			if (searchItemId) {
				payload.itemid = searchItemId;
			}
		}

		getPricingDistrictLevelData(payload)
			.then((res: any) => {
				if (res.data) {
					let newList = JSON.parse(JSON.stringify(customerList));

					newList.map((item: any, k: any) => {
						if (item.sku === itemID) {
							res.data.data = res.data.data?.sort(
								(x: any, y: any) =>
									y.lostOpportunity - x.lostOpportunity
							);
							item.divisionList.map((d: any, dIndex: any) => {
								if (d.district == peerGroupDistrict) {
									d.peerData.map((p: any, pIndex: any) => {
										if (p.peerGroupName == peerGroupName) {
											newList[k].divisionList[
												dIndex
											].peerData[pIndex].customerData =
												res.data.data;
										}
									});
								}
							});
						}
					});

					setCustomerList(newList);
				}
				//   setLoading(false);
			})
			.catch((err) => {
				//   setLoading(false);
				console.log(err);
			});
	};

	const getPricingExport = async () => {
		toaster.push(message, { placement: "topCenter" });
		let payload: any = {
			l1: selectedFilters.l1,
			l2: selectedFilters.l2,
			l3: selectedFilters.l3,
			l4: selectedFilters.l4,
		    timeline: selectedTimeline,
			projectFlag: [],
			district: [],
			custMarket: [],
			salesOffice: [],
			custSize: [],
			startification: [],
			customerSubMarket: [],
			customer: "",
			itemid: "",
			pageNumber: pageNumber,
			pageSize: 10,
		};

		if (extraFilters) {
			payload.projectFlag = extraFilters.projectFlag;
			payload.district = extraFilters.district;
			payload.custMarket = extraFilters.custMarket;
			payload.salesOffice = extraFilters.salesOffice;
			payload.custSize = extraFilters.custSize;
			payload.startification = extraFilters.startification;
			payload.customerSubMarket = extraFilters.customerSubMarket;
		}

		if (searchCustName) {
			payload.customer = searchCustName;
		}
		if (searchItemId) {
			payload.itemid = searchItemId;
		}

		let res = await dispatch(getPricingExportData(payload));
		if (res.data) {
			res.data.map((item: any) => {
				item.revenue = `$${item.revenue.toFixed(0)}`;
				item.price = `$${item.price.toFixed(2)}`;
				item.peer_price = `$${item.peer_price.toFixed(2)}`;
				item.FloorPrice = `$${item.FloorPrice.toFixed(2)}`;
				item.projectedOpportunity = `$${item.projectedOpportunity.toFixed(
					0
				)}`;
			});
			setExportFlag(true);
			setExportData(res?.data);
		}
	};

	const customerDivisionData = async (data: any) => {
		let payload = {
			itemId: data?.itemId,
			district: data?.district,
			peerGroupName: data?.peerGroupName,
			master_vendor_name: data?.master_vendor_name,
			customer: data?.customerID,
      		timeline: selectedTimeline,
		};
		setIsLoading(true);
		getPricingDivsionDataByCustomer(payload)
			.then((res: any) => {
				setIsLoading(false);
				if (res.data) {
					setCustomerPricingData(res.data);

					let minYAxis = Infinity;
					let maxYAxis = -Infinity;
					let itemDesc = "";
					res?.data.forEach((d: any) => {
						console.log(d.price, d.FloorPrice, d.peer_price);
						let minVal = Math.min(
							...[d.price, d.FloorPrice, d.peer_price]
						);
						minYAxis = minVal < minYAxis ? minVal : minYAxis;
						maxYAxis = Math.max(
							...[d.price, d.FloorPrice, d.peer_price]
						);

						if (data?.customer === d?.Customer) {
							setSelectedCustomerData(d);
						}
						// if (maxYAxis < d.price) {
						//   maxYAxis = d.price;
						// }
						// if (minYAxis > d.price) {
						//   minYAxis = d.price;
						// }

						itemDesc = d.itemDesc;
						d.copyAxecutedPrice = d.FloorPrice;
					});
					minYAxis = Math.round(minYAxis);
					maxYAxis = Math.round(maxYAxis);

					if (minYAxis > 10 && minYAxis < 500) {
						minYAxis = minYAxis - 2;
					} else if (minYAxis > 500 && minYAxis < 1000) {
						minYAxis = minYAxis - 100;
					} else if (minYAxis > 1000 && minYAxis < 10000) {
						minYAxis = minYAxis - 500;
					} else {
						minYAxis = minYAxis - 0.5;
					}

					console.log(minYAxis, 123);

					setMinYAxisValue(minYAxis);
					setMaxYAxisValue(maxYAxis);
					setSelectedCustomerList(data?.customer);
				}
				//   setLoading(false);
			})
			.catch((err) => {
				//   setLoading(false);
				console.log(err);
			});
	};

	const getExportData = () => {
		getPricingExport();
	};

	useEffect(() => {
		if (token) {
			getFilters();
			getCustomerData();
		}
	}, [pageNumber, token]);

	useEffect(() => {
		if (token) {
		getCustomerData();
		getFilters();
		setSelectedCustomer(null);
		}
	}, [selectedTimeline]);

	// useEffect(() => {
	//   if (didMount.current) {
	//   getFilters();
	//   getCustomerData();
	//   }
	// }, []);

	return (
		<div className="pricing-container w-full">
			<MainHeader
				onVisibilityChange={setIsVisible}
				isRightVisible={isRightVisible}
				setIsRightVisible={setIsRightVisible}
				bottomContent={
					<>
						{Object.keys(filterOptions).length > 0 && (
							<div className="flex items-center justify-between w-full">
								{/* Left side - Filters */}
								<div className="flex items-center gap-x-3 flex-wrap">
									<div className="sub-heading-text font-bold flex flex-col items-start">
										<span className="filterHead">
											Timeline
										</span>
										<SelectPicker
											data={timelineOptions.length ? timelineOptions : []}
											placeholder="All"
											value={selectedTimeline}
											 defaultValue={
													timelineOptions.length ? timelineOptions[0].value : ""
												}
											onChange={timelineHandler}
											cleanable={false}
										/>
									</div>
									{["l1", "l2", "l3", "l4"].map(
										(
											filterEntity: string,
											index: number
										) => {
											return (
												<div
													className="sub-heading-text font-bold flex flex-col items-start"
													key={filterEntity}
												>
													<span className="filterHead">
														{filterEntity}
													</span>
													<CheckPicker
														data={
															filterOptions[
																filterEntity
															].length
																? filterOptions[
																		filterEntity
																  ]
																: []
														}
														placeholder="All"
														labelKey={
															filterEntity ==
															"supplier"
																? "vendor"
																: filterEntity
														}
														valueKey={
															filterEntity ==
															"supplier"
																? "vendor"
																: filterEntity
														}
														placement={
															filterEntity == "l4"
																? "bottomEnd"
																: "bottomStart"
														}
														value={
															selectedFilters[
																filterEntity
															]
																? selectedFilters[
																		filterEntity
																  ]
																: []
														}
														onClose={() =>
															filtersMount?.current
																? handleClose(
																		filterEntity
																  )
																: ""
														}
														onClean={() => {
															handleClear(
																filterEntity
															);
														}}
														onChange={(
															value: any
														) =>
															handleFilterUpdate(
																value,
																filterEntity
															)
														}
														loading={filtersLoading}
														renderExtraFooter={() => (
															<div
																style={
																	footerStyles
																}
															>
																<Checkbox
																	indeterminate={
																		selectedFilters[
																			filterEntity
																		]
																			?.length >
																			0 &&
																		selectedFilters[
																			filterEntity
																		]
																			?.length <
																			filterOptions[
																				filterEntity
																			]
																				?.length
																	}
																	checked={
																		selectedFilters[
																			filterEntity
																		]
																			?.length ===
																		filterOptions[
																			filterEntity
																		]
																			?.length
																	}
																	onChange={(
																		value: any
																	) =>
																		handleFilterUpdate(
																			"all",
																			filterEntity
																		)
																	}
																>
																	Check all
																</Checkbox>
															</div>
														)}
													/>
												</div>
											);
										}
									)}
								</div>
								{/* Right side - Inputs and Button */}
								<div className="flex items-center gap-x-3 flex-shrink-0">
									<input
										type="text"
										maxLength={8}
										minLength={8}
										className="px-[1vh] w-[8vw] h-[4vh] text-black rounded-md bg-[#f9fafb] border border-[bebebe]"
										placeholder="Item ID"
										value={searchItemId ? searchItemId : ""}
										onChange={(e: any) => {
											setSearchItemId(e.target.value);
										}}
									/>
									<input
										type="text"
										placeholder="Customer ID"
										className="px-[1vh] w-[8vw] h-[4vh] text-black rounded-md bg-[#f9fafb] border border-[bebebe]"
										value={
											searchCustName ? searchCustName : ""
										}
										onChange={(e: any) => {
											setSearchCustName(e.target.value);
										}}
									/>
									<Button
										className="customButton h-[4vh]"
										onClick={() => {
											handleSearch();
											setSelectedCustomer(null);
											setPageNumber(1);
										}}
									>
										Search
									</Button>
								</div>
							</div>
						)}
					</>
				}
				topContent={
					<div className="flex justify-between items-center w-full">
						<div className="text-left pageline">
							<span className="pagelinestart">
								Commercial and Pricing
							</span>
							<span className="pagelineslash">/</span>
							<span className="pagelinesub">
								Commercial Optimization
							</span>
						</div>
					</div>
				}
			></MainHeader>
			<MainContent isVisible={isVisible} fullHeight={true}>
				<div className="chart-flex h-[100%]">
					<div className="suppliers contentBox ">
						<div className="headSpace pb-[2vh]">
							<Filters
								className=" customfilter"
								handleFilterChange={(filterData: any) => {
									setExtraFilters(filterData);
									setPageNumber(1);
									getCustomerData(null, null, filterData);
									setSelectedCustomer(null);
									setSelectedItemId(null);
									setSelectedDistrict(null);
									setSelectedPeerName(null);
								}}
								data={initialFilterValues}
							/>
						</div>

						{/* Filters */}

						{tableLoading ? (
							<div className="w-full h-[90%]">
								<Loader />{" "}
							</div>
						) : (
							<CustomerSummaryTable
								data={customerList}
								count={count}
								totalOppAndRev={totalOppAndRev}
								pageNumber={pageNumber}
								exportData={exportData}
								ExportFlag={ExportFlag}
								updateExportFlag={(flag: any) => {
									setExportFlag(flag);
								}}
								selectedFilters={selectedFilters}
								extraFilters={extraFilters}
								getExportData={getExportData}
								updatesetExportFlag={() => {
									setExportFlag(false);
									setExportData([]);
								}}
								updatePageNumber={(page: any) => {
									setPageNumber(page);
								}}
								selectedCustomerList={selectedCustomerList}
								updateSelectedCustomerList={(data: any) => {
									customerDivisionData(data);
								}}
								updateSelectedCustomer={(data: any) => {
									setSelectedCustomer(data);
								}}
								updateDivisionList={(
									itemID: any,
									master_vendor_name: any
								) => {
									getDivisionList(itemID, master_vendor_name);
								}}
								updateCustomerList={(
									itemID: any,
									master_vendor_name: any,
									peerGroupDistrict: any,
									peerGroupName: any
								) => {
									getCustomerList(
										itemID,
										master_vendor_name,
										peerGroupDistrict,
										peerGroupName
									);
								}}
								selectedCustomer={selectedCustomer}
							/>
						)}
					</div>

					<div
						className={` contentBox h-[100%] w-[40%]${
							selectedCustomer ? "" : ""
						}`}
					>
						{selectedCustomer ? (
							<>
								{isLoading && (
									<div className="w-full h-full border-[1px solid] border-[#bebebe]">
										<Loader />
									</div>
								)}
								{!isLoading && (
									<div className="w-full ">
										<div className="common-table-header-row">
											<div className="common-table-header">
												{selectedCustomer && (
													<div
														style={{
															display: "flex",
															alignItems:
																"center",
														}}
													>
														<span>
															{
																selectedCustomerData?.customerName
															}{" "}
															- Pricing and
															Opportunity
														</span>
														{/* <Whisper
															placement="bottom"
															trigger="hover"
															speaker={
																<Popover>
																	<DivisionWiseTable
																		data={
																			selectedCustomerData
																		}
																	/>
																</Popover>
															}
														>
															<InfoOutlineIcon className="ml-2" />
														</Whisper> */}
													</div>
												)}
											</div>
										</div>
										<div className="flex justify-stretch gap-4 items-center basis-[7%] w-full grow-0 text-black my-2">
											<div className="flex flex-row items-center justify-between gap-4 basis-1/2 px-[1vh] py-[0.5vh] bg-white border border-[#bebebe]">
												<span className="font-semibold textNormal">
													Opportunity
												</span>
												<span className="font-bold textLarge">
													{numberFormatter(
														selectedCustomerData?.projectedOpportunity,
														2,
														"$"
													)}
												</span>
											</div>
											<div className="flex flex-row items-center justify-between gap-4 basis-1/2 px-[1vh] py-[0.5vh] bg-white border border-[#bebebe]">
												<span className="font-semibold textNormal">
													Revenue
												</span>
												<span className="font-bold textLarge">
													{numberFormatter(
														selectedCustomerData?.revenue,
														1,
														"$"
													)}{" "}
													Per Year
												</span>
											</div>
										</div>

										<div className="w-full h-[75%] flex text-black">
											<div
												className={`w-[100%] ${
													isVisible
														? "h-[42vh]"
														: "h-[50vh]"
												} pl-2`}
											>
												<BubbleScatterWithZoom
													label={"Vol/Drop"}
													customerData={
														customerPricingData
													}
													graphWidth={
														window.innerWidth - 275
													}
													graphHeight={
														window.innerHeight - 275
													}
													minYAxis={minYAxisValue}
													maxYAxis={maxYAxisValue}
													selectedCustomerData={
														selectedCustomerData
													}
													openPopup={false}
													referenceLine={
														customerPricingData.price
													}
													tableHeight={"28vh"}
												/>
											</div>
											<div
												className={`w-[60%]  ${
													isVisible
														? "h-[48vh]"
														: "h-[48vh]"
												} pl-2`}
											>
												<DivisionWiseTable
													data={selectedCustomerData}
												/>
											</div>
										</div>
									</div>
								)}
							</>
						) : (
							<div className="flex justify-center items-center h-full w-full">
								<span className="text-black text-[2.5vh] italic font-normal text-center">
									Please select an Item ID to get District and Customer level pricing details
								</span>
							</div>
						)}
					</div>
				</div>
			</MainContent>
		</div>
	);
};
const message = (
	<Notification type={"info"} header={`Exporting...`} closable>
		<p>Your file is being created. It will be download automatically </p>
	</Notification>
);

export default Pricing;
